import React, { Component } from "react";
import { NavLink } from "react-router-dom";
export default class Header extends Component {
	constructor() {
      super();
      this.state = {
          scrollActive: 'hidden'
      };
  }
	showMenu = () =>{
		if(this.state.mobileMenuActive === 'active'){
			this.setState({mobileMenuActive: 'hidden'})
		} else{
		    this.setState({mobileMenuActive: 'active'})
		}

	}
	render() {
		return (
			<div>
				<div id="header" className="top-bar">
					<div className={this.state.scrollActive}>
						<div className="logo-container">
							<NavLink exact to="/" >
								<img alt="" className="logo logo-dark" src="images/logo-dark.png" />
								<img alt="" className="logo logo-light" src="images/logo-light.png" />
							</NavLink>
						</div>
						<nav>
							<div className="hide-for-small">
								<NavLink to="/work">Case Studies</NavLink>
								<NavLink to="/services">Services</NavLink>
								<NavLink to="/about">About</NavLink>
								<NavLink to="/contact">Contact</NavLink>
							</div>
							<div id="mobile-menu-icon" className="show-for-small" onClick={this.showMenu}>
								<img alt="" className="mobile-menu-icon-light full-width" src="/images/menu-light.png" />
								<img alt="" className="mobile-menu-icon-dark full-width" src="/images/menu-dark.png" />
							</div>
						</nav>
						<div className="top-bar-background"></div>
					</div>
				</div>
				<div id="mobile-menu" className={this.state.mobileMenuActive}>
					<div className="top-bar">
						<div className="logo-container">
						</div>
						<nav>
							<div id="mobile-menu-icon" className="show-for-small" onClick={this.showMenu}>
								<img alt="" className="mobile-menu-icon-light full-width" src="/images/close-icon.png" />
							</div>
						</nav>
					</div>
					<div className="mobile-menu-content">
						<NavLink exact to="/" onClick={this.showMenu}>
							<img alt="" className="logo logo-light" src="images/logo-light.png" />
						</NavLink>
						<NavLink to="/work" onClick={this.showMenu}>Case Studies</NavLink>
						<NavLink to="/services" onClick={this.showMenu}>Services</NavLink>
						<NavLink to="/about" onClick={this.showMenu}>About</NavLink>
						<NavLink to="/contact" onClick={this.showMenu}>Contact</NavLink>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/header.js